import { PopupRequest, PublicClientApplication, SilentRequest } from '@azure/msal-browser';
import { UserCache } from '../caches';
import { JwtAuthService } from './jwt-auth.service';
import { AzureAuthenticationError } from '../../types';
import { createUUID } from '../../common';
import { ClientSettingsService } from '../modules';
import { MSInfo } from '@nt-portal/server-sdk';


export class AzureLoginService {

    private static scopes = ["Calendars.Read", "Mail.Read", "Mail.Send", "user.read", "openid", "profile", "email", "https://graph.microsoft.com/User.Read"];

    private static async msalInstance(msConfig: MSInfo) {



        const msalConfig = {
            auth: {
                clientId: msConfig.clientId,
                authority: msConfig.identity
            }
        };

        const msalInstance = new PublicClientApplication(msalConfig);
        return msalInstance;
    }


    public static get redirectUrl() {
        let origin = window.location.origin;
        let url = `${origin}/signin`;
        return url;
    }

    public static async msConfig() {
        let service = new ClientSettingsService();
        return await service.msConfig();

    }

    public static async login() {

        const msConfig = await AzureLoginService.msConfig();

        const msalInstance = await AzureLoginService.msalInstance(msConfig);

        var loginRequest: PopupRequest = {
            scopes: AzureLoginService.scopes,
            redirectUri: AzureLoginService.redirectUrl,
            authority: msConfig.identity,
            correlationId: createUUID(),
            state: createUUID()
        }

        let jwtAuth = new JwtAuthService();

        try {

            const loginResponse = await msalInstance.loginPopup(loginRequest);

            if (!loginResponse.account) {
                throw new Error("Microsoft sign-in did not return an account.");
            }

            const silentRequest: SilentRequest = {
                scopes: AzureLoginService.scopes,
                account: loginResponse.account,
                authority: msConfig.identity,
                forceRefresh: true,
                correlationId: createUUID()
            };

            // Bypass MSAL's access-token cache before exchanging the Microsoft
            // ID token for an application token on the server.
            const freshLoginResponse = await msalInstance.acquireTokenSilent(silentRequest);
            if (!freshLoginResponse.idToken) {
                throw new Error("Microsoft sign-in did not return an ID token.");
            }

            UserCache.idToken = freshLoginResponse.idToken;
            UserCache.authenticationResult = freshLoginResponse;

            let token = await jwtAuth.silentLogin();

            UserCache.idToken = token;

            return token;

        }
        catch (ex) {
            let error = ex as Error;
            throw new AzureAuthenticationError(error.message);
        }

    }
}
